module.exports = __webpack_public_path__ + "img/details-badge.93767c40.png";